export function compressSaveAspectRatio(source, width, quality) {
	if (source.naturalWidth > width) {
		const aspectRatio = source.naturalWidth / source.naturalHeight;
		const height = width / aspectRatio;

		return compress(source, width, height, quality);
	} else {
		return compress(source, source.naturalWidth, source.naturalHeight, quality);
	}
}

export default function compress(source, width, height, quality) {
	const type = 'image/jpeg';
	
	const canvas = document.createElement('canvas');
	const ctx = canvas.getContext('2d');

	canvas.width = width;
	canvas.height = height;
	ctx.drawImage(source, 0, 0, width, height);

	return new Promise((resolve, reject) => {
		canvas.toBlob(blob => resolve(blob), type, quality);
	});
}




// WEBPACK FOOTER //
// ./src/util/compressor.js